import React from 'react';

const STEP_LABELS = [1, 50, 100, 150, 200, 250, 300, 350, 400];

function ResidenceSlider({ value, onChange }) {
  return (
    <div className="w-full">
      <input
        type="range"
        min={1}
        max={400}
        step={1}
        value={value}
        onChange={(event) => onChange(Number(event.target.value))}
        className="w-full h-2 rounded-lg appearance-none cursor-pointer accent-secondary bg-gray-200"
      />
      <div className="flex justify-between mt-2 text-xs md:text-sm text-gray-500">
        {STEP_LABELS.map((label) => (
          <span key={label}>{label}</span>
        ))}
      </div>
    </div>
  );
}

export default ResidenceSlider;
